var isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;

if(filter_selected=="drawer"){

  if(!isMobile){
    jQuery('.dev-grid-sidebar').hide();


  }
  var collection_product_width=jQuery('.dev-grid').width();
  var filterwidth=collection_product_width*(20/100);
  var productwidth=collection_product_width-filterwidth;
  jQuery(document).ready(function(){


    jQuery('body').on('click','#btn-cm-filter',function(){

      if(jQuery(this).hasClass('btn-cm-drawer')){
        closedeskdrawer();

      }else{
        opendeskdrawer();
      }

    });
    jQuery('body').on('click','.close-custom-drawer',function(){

      closedeskdrawer();
    });


    if(isfilter_open=="yes" && !isMobile){
      opendeskdrawer2();     

    }
    if( !isMobile){
      collection_filter();

    }

  });
  function opendeskdrawer(){ 
    // console.log(1234);

    //   var filterhtml= jQuery('.sidebar_filters_step').html();
    // jQuery('.cm-filter-body').html(filterhtml);
    jQuery(".dev-grid-product").animate({
      width:productwidth
    }, 300, 'linear');
    jQuery(".dev-grid-sidebar").animate({
      width:filterwidth
    }, 300, 'linear');  
    var isfilter_open="yes";

    jQuery('#btn-cm-filter').addClass('btn-cm-drawer');
    jQuery('.dev-grid-sidebar').addClass('dev-filter-show');
    jQuery('.dev-grid-product').addClass('dev-product-drawer');
    jQuery('.dev-collection-subarea').show();
    jQuery('.cm-filter-header').show();
    jQuery('.dev-grid-sidebar').show();

  }
  function opendeskdrawer2(){ 

    jQuery(".dev-grid-product").animate({
      width:productwidth
    }, 5, 'linear');
    jQuery(".dev-grid-sidebar").animate({
      width:filterwidth
    }, 5, 'linear');  
    //jQuery(".dev-grid-product").attr("style",productwidth);
    //     jQuery(".dev-grid-sidebar").attr("style",filterwidth);  
    //    var isfilter_open="yes";

    jQuery('#btn-cm-filter').addClass('btn-cm-drawer');
    jQuery('.dev-grid-sidebar').addClass('dev-filter-show');
    jQuery('.dev-grid-product').addClass('dev-product-drawer');
    jQuery('.dev-collection-subarea').show();
    jQuery('.cm-filter-header').show();
    jQuery('.dev-grid-sidebar').show();


  }
  function closedeskdrawer(){
    jQuery(".dev-grid-product").animate({
      width:collection_product_width
    }, 300, 'linear');
    jQuery(".dev-grid-sidebar").animate({
      width: 0
    }, 300, 'linear');
    jQuery('.dev-grid-sidebar').removeClass('dev-filter-show');
    jQuery('.dev-grid-product').removeClass('dev-product-drawer');

    jQuery('#btn-cm-filter').removeClass('btn-cm-drawer');
    setTimeout(function(){ 
      jQuery('.dev-collection-subarea').hide();
      jQuery('.cm-filter-header').hide();
      jQuery('.dev-grid-sidebar').hide();


    }, 200);


  }
  function collection_filter(){
    jQuery('.dev-filter-btn-main .filter-2').html('');     
    jQuery('.dev-filter-btn-main .filter-3').html('');

    jQuery('.dev-filter-btn-main .filter-2').append(jQuery('.collection-filter .filter-2').html());
    jQuery('.dev-filter-btn-main  .filter-3').append(jQuery('.collection-filter .filter-3').html());
    jQuery('.collection-filter .filter-2').html('');
    jQuery('.collection-filter .filter-3').html('')
  }

}
else if(filter_selected=="sidebar"){
  function opendeskdrawer(){ 
    // console.log(1234);
  }
  function collection_filter(){

  }

  function opendeskdrawer2(){ 
    // console.log(1234);
  }
  jQuery('.dev-filter-btn-main').hide();

}else{
  function collection_filter(){

  }
  function opendeskdrawer(){ 
    // console.log(1234);
  }
  function opendeskdrawer2(){ 
    // console.log(1234);
  }
}

jQuery('body').on('click','.quick-product__btn_mobile',function(e){
  var prdid=jQuery(this).attr('data-product-id');
  jQuery('.quick-product__btn[data-product-id="'+prdid+'"]').trigger('click');
});

//======================================Preorder Product=================================================

//PREORDER
jQuery(document).on('click','.thispreorder',function(e){
 
   e.preventDefault();
  var form = jQuery(this).parents('form');

  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');

//console.log(cartsize+'====='+carthas_holiday);
  if(cartsize==0 || carthas_holiday==true || carthas_holiday=="true"){
                       form.submit();
  }else{
       go__alert("Please purchase the Holiday Box in a separate order or remove other products from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items." );

  }
 
  
});
$(document).on('submit','.modal .preorder__form',function(){
 
  var form=$(this);
  
  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');
//console.log(cartsize+'====='+carthas_holiday);


  if(cartsize==0 || carthas_holiday==true || carthas_holiday=="true"){
                       form.submit();
  }else{
     go__alert("Please purchase the Holiday Box in a separate order or remove other products from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items." );

  }
 
 
return false;
});
//======================================Holiday=================================================
//Holiday Form
jQuery(document).on('click','.thisholiday',function(e){
 
   e.preventDefault();
  var form = jQuery(this).parents('form');
  var prdid=jQuery(this).attr('data-prdid');

  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');

//console.log(cartsize+'====='+carthas_holiday);
  if(cartsize==0 || carthas_holiday==true || carthas_holiday=="true"){
  //caretajax

      if(prdid==4695353983059 || prdid=="4695353983059" ){
              var var_id = "0";

  var var__val=jQuery("body .holiday_gift_class input[type='radio']:checked").val();
 jQuery.getJSON('/products/' + 'holiday-box-necklace' + '.js', function (product) {
          //  console.log(product.variants);
                     //             console.log("================="+var__val);

            $(product.variants).each(function (i, v) {
            //  console.log(v.title+"===="+v.id);
             if (v.title == var__val) {
                var_id = v.id;
                jQuery.post('/cart/add.js', {
              quantity: "1",
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
                                       form.submit();
            })
            .fail(function ($xhr) {
                                  //     form.submit();
                 var data = $xhr.responseJSON;
              
                  go__alert(data.description );

              });
              }
            });
          });
             
      }else{
        form.submit();
      }
    //cartajax
  }else{
       go__alert("Please purchase the Holiday Box in a separate order or remove other products from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items." );

  }
 
  
});
//HOLIDAY MODAL FORM
$(document).on('submit','.modal .holiday__form',function(){
  
        var form=$(this);
    var prdid=jQuery(this).attr('data-prdid');
  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');
//console.log(cartsize+'====='+carthas_holiday);


  if(cartsize==0 || carthas_holiday==true || carthas_holiday=="true"){

             
      if(prdid==4695353983059 || prdid=="4695353983059" ){
        var var_id = "0";

  var var__val=jQuery("body .holiday_gift_class input[type='radio']:checked").val();
 jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          //  console.log(product.variants);
                         //      console.log("================="+var__val);

            $(product.variants).each(function (i, v) {

             if (v.title == var__val) {
                var_id = v.id;
                 jQuery.post('/cart/add.js', {
              quantity: "1",
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
                                       form.submit();
            })
            .fail(function ($xhr) {
                                  //     form.submit();
                 var data = $xhr.responseJSON;
              
                  go__alert(data.description );

              });
              }
            });
          });
            
      }else{
        form.submit();
      }
                }else{
     go__alert("Please purchase the Holiday Box in a separate order or remove other products from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items." );

  }
 
 
return false;
});


//======================================Main Product=================================================

// For Main RPoduct

jQuery(document).on('click','.thismainform',function(e){
  e.preventDefault();
  var form = jQuery(this).parents('form');


  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');

  if(cartsize==0 || carthas_holiday==false || carthas_holiday=="false"){
                     form.submit();
  }else{
          go__alert("Please purchase in a separate order or remove the Holiday Box from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items. Please note: this is a pre-order item and will ship out the first week of December via courier." );

  }
 

});

$(document).on('submit','.modal .mainprd__form',function(){
  var form=$(this);

  var carthas_holiday=jQuery("#carthas_holiday").val();
    var cartsize=jQuery("#carthas_holiday").attr('data-cartsize');

//console.log(cartsize+'====='+carthas_holiday);
  if(cartsize==0 || carthas_holiday==false || carthas_holiday=="false"){
                      form.submit();
  }else{
          go__alert("Please purchase in a separate order or remove the Holiday Box from your cart to purchase this product. To ensure a speedy delivery before the holidays, the Holiday box will ship separately and cannot be combined with any other items. Please note: this is a pre-order item and will ship out the first week of December via courier." );

  }
  return false;

});
function go__alert(message){

 Swal.fire({

    position: 'center',
    title: message,

    confirmButtonColor: '#f5b3c2',


    confirmButtonText: 'OK'

  }).then((result) => {

    
  }); 
}

//function to check thumnail position
function check_thumbposition(index){
  alert(index);
if( 2 == index ){
                alert("Slide 2");
            };
}